import { Component } from '@angular/core';
import { Checkbox } from '../../core/ui/inputs/checkbox/checkbox';
import { TextInputComponent } from '../../core/ui/inputs/textbox/textbox';
import { Selectbox } from '../../core/ui/inputs/selectbox/selectbox';
import { Radiobox } from '../../core/ui/inputs/radiobox/radiobox';
import { Rangebox } from '../../core/ui/inputs/rangebox/rangebox';
import { Onoff } from '../../core/ui/inputs/onoff/onoff';
import { TextModes } from '../../core/ui/inputs/textbox/textbox';
import { ListItem } from '../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-styles-page',
  imports: [Checkbox, TextInputComponent, Selectbox, Radiobox, Rangebox, Onoff],
  templateUrl: './styles-page.html',
  styles: ``,
})
export class StylesPage {

  TextModes = TextModes;


  options:ListItem[] = [
    new ListItem({id: "1", name: "Option 1"}),
    new ListItem({id: "2", name: "Option 2"}),
    new ListItem({id: "3", name: "Option 3"}),
  ];
}
